import { OrderItemType } from '@ca/common/types'
import { StepOption } from '@order/hooks/useOrderStep'
import useOrderValues from '@order/hooks/values/useOrderValues'
import useStepsState from '@order/hooks/useStepsState'
import { VariablesUtils } from '@order/utils/OrderVariables'
import { resolveVariants } from '@order/utils/resolveVariants'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { useCallback } from 'react'

export const isUpgradeItem = (item: {
  type: OrderItemType
  active: { value: string }
}) => {
  return item.type === 'upgrade'
}

const useUpgradeItems = (stepId: string | number) => {
  const config = useRemoteConfig()
  const { states } = useStepsState()
  const { values, refraction } = useOrderValues({ states })

  return useCallback(
    (selected: StepOption) => {
      if (!config || !refraction || !values) {
        return []
      }

      const step = config.steps[stepId]
      if (!step) {
        return []
      }

      const items = resolveVariants({
        config,
        refraction,
        step,
        values: {
          ...values,
          [selected.variable]: selected.active.value,
          ...VariablesUtils.fromOverrides(selected.active.overrides),
        },
      })

      return items.filter(isUpgradeItem)
    },
    [config, refraction, values, stepId]
  )
}

export default useUpgradeItems
